import type { StaticEntityType } from "@config";
import { Set } from "@library-containers/layers";
import { Fragment } from "react";
import { TabsProvider } from "../providers";
import type { TabTitleType, TabsPayload } from "../types";
import {
  getItemsInRow,
  getPlaceholders,
  getTabsOptions,
  getTitlePositionAttributes,
} from "../utils";
import { TabsView } from "./Tabs.view";
import { Title } from "./Title";
import { Titles } from "./Titles";
import { Wrapper } from "./Wrapper";

export const TabsPdf = ({ entity }: { entity: StaticEntityType }) => {
  const titles = getTabsOptions(entity) as unknown as TabTitleType[];
  const { settings, children, id } = entity as StaticEntityType<TabsPayload>;

  const itemsInRow = getItemsInRow({ settings, length: titles.length });
  const { placeholdersCount, maxItems } = getPlaceholders({
    length: titles.length,
    itemsInRow,
    design: settings.tabsDesign,
  });

  return (
    <div className="tw-grid tw-w-full tw-gap-32">
      {children.map((child: StaticEntityType) => (
        <Fragment key={child.id}>
          <TabsProvider id={child.id}>
            <TabsView entity={entity}>
              <Titles entitiesLength={titles.length} settings={settings}>
                {titles.map((title, index) => (
                  <Title
                    settings={settings}
                    title={title}
                    key={title.id}
                    attributes={getTitlePositionAttributes({
                      index,
                      tabsInRow: itemsInRow,
                      total: titles.length + placeholdersCount,
                      max: maxItems,
                      design: settings.tabsDesign,
                    })}
                  />
                ))}
              </Titles>
              <div className="tw-w-full">
                {children.map((child: StaticEntityType, index: number) => (
                  <Wrapper id={child.id} isMobile={false} key={child.id}>
                    <Set
                      entity={{
                        ...child,
                        layers: {
                          ...(entity.layers || {}),
                          combo: { settings, index, id },
                        },
                      }}
                    />
                  </Wrapper>
                ))}
              </div>
            </TabsView>
          </TabsProvider>
        </Fragment>
      ))}
    </div>
  );
};
